import { languages } from '../configs/userPreferences/languages';
import { hostStyles } from '../configs/userPreferences/hostStyles';
import { weightedRandomItem } from './randomSelection';
// Language utilities
function findLanguageConfig(value) {
    return languages.find((lang) => lang.value === value);
}
export function findLanguageLabel(value) {
    return findLanguageConfig(value)?.label;
}
export function findLanguageAlphabet(value) {
    return findLanguageConfig(value)?.alphabet;
}
export function findLanguageAlphabetWeights(value) {
    return findLanguageConfig(value)?.alphabetWeights;
}
/**
 * Selects a random item from an array based on provided weights.
 * @param items - Array of items to choose from
 * @param weights - Array of weights (must match items length, should sum to 100 or any positive total)
 * @returns A randomly selected item based on weighted probability
 */
export function weightedRandomLetter(items, weights) {
    return weightedRandomItem(items, weights);
}
// Accent utilities
export function findAccentConfig(languageValue, accentValue) {
    const language = findLanguageConfig(languageValue);
    return language?.accents.find((accent) => accent.value === accentValue);
}
export function findEnabledAccents(languageValue) {
    const language = findLanguageConfig(languageValue);
    return language?.accents.filter((accent) => !accent.disabled) || [];
}
export function findAccentLabel(languageValue, accentValue) {
    return findAccentConfig(languageValue, accentValue)?.label;
}
// Host style utilities
export function findHostStyleConfig(personality, gender) {
    return hostStyles.find((style) => style.personality === personality && style.gender === gender);
}
export function findEnabledHostStyles() {
    return hostStyles.filter((style) => !style.disabled);
}
// Validation utilities
export function getEnabledLanguageValues() {
    return languages.filter((lang) => !lang.disabled).map((lang) => lang.value);
}
export function getEnabledAccentValues() {
    return languages
        .filter((lang) => !lang.disabled)
        .flatMap((lang) => lang.accents.filter((acc) => !acc.disabled).map((acc) => acc.value));
}
// Voice actor utilities
export function getEnabledVoiceActors() {
    return [
        ...new Set(hostStyles.filter((h) => !h.disabled).map((h) => h.voiceActor)),
    ];
}
//# sourceMappingURL=getUserPreferences.js.map